<template>
  <div class="c-gather-info-page-wrapper">
    <div class="c-refresh-wrapper">
      <button class="c-btn c-btn-sm c-btn-default" v-on:click="refreshPage()"><i class="fa fa-refresh" aria-hidden="true"></i> Osvezi stranicu</button>
    </div>
    <div class="c-loading-content-wrapper">
      <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      <div class="c-loading-txt"><b>Ucitavanje podataka korisnika..</b></div>
    </div> 
  </div>
</template>

<script>
import EventBus from '@/EventBus'
import Firebase from 'firebase'
import {firebaseDB} from '@/firebase';
//import router from '@/router/index'
//
export default {
  name: 'GatherUserInfo',
  data: function() {
    return {
      testMsg: 'GatherUserInfo component right here',
      temp_FirebaseUserData: {
        currentUser: null,
        userDetails: null,
        isOnline: false
      }
    }
  },
  methods: {
    refreshPage: function () {
      location.reload(true);
    }  
  },
  created: function () {
    /*
      !!!-IMPORTANT - Purpose of this component is to GATHER ALL INFORMATIONS ABOUT USER before other Vue components (views) are rendered
      We have to wait to get all required informations before showing Events, Guests, Events Archive and other views
     */
    console.log('||-created: GatherUserInfo');
    this.temp_FirebaseUserData.currentUser = Firebase.auth().currentUser;      
    // Check if logged user is authenticated
    if (this.temp_FirebaseUserData.currentUser){
      // !!!-IMPORTANT - If user is authenticated, then we must gather OTHER USER INFO (first name, last name, phone, access level..)
      let tmp_userDetails = firebaseDB.ref('listOfUsers/' + this.temp_FirebaseUserData.currentUser.uid).once('value').then(
        function(snapshot) {
        //console.log('User Details Success');
        this.temp_FirebaseUserData.userDetails = snapshot.val();
        EventBus.$emit('event_userDataGathered', this.temp_FirebaseUserData);
        //console.log('getFirebaseUserData firebaseDB_User in MainApp: ' + JSON.stringify(temp_FirebaseUserData, null, 2));
      }.bind(this), function(error) {
        console.log('User Details Error');
      }.bind(this));
    }else{
      console.log('There is no user token')
    }
  },
  destroyed(){
    EventBus.$off('event_userDataGathered', this.temp_FirebaseUserData);
  }  
}
</script>

<style>  
/* "scoped" attribute limit the CSS to this component only */
</style>



// WEBPACK FOOTER //
// src/components/GatherUserInfo.vue